import { defineMessages } from 'react-intl';

export default defineMessages({
  tooltipText: {
    id: 'frontbucket.jiraPage.projectMenu.tooltipText',
    description: 'Text in the tooltip for relevant project dropdown.',
    defaultMessage: `Linked Jira projects`,
  },
  groupHeaderLabel: {
    id: 'frontbucket.jiraPage.projectMenu.groupHeaderLabel',
    description: 'Label for the relevant project options group header.',
    defaultMessage: `Linked Jira projects`,
  },
  errorLoadingMessage: {
    id: 'frontbucket.jiraTab.projectMenu.errorLoadingMessage',
    description: 'Message displayed when failed to load relevant projects.',
    defaultMessage: `We can't load the project list.`,
  },
  noLinkedProjectsMessage: {
    id: 'frontbucket.jiraTab.projectMenu.noLinkedProjectsMessage',
    description: 'Message displayed when there are no linked projects.',
    defaultMessage: `You haven’t linked a project yet.`,
  },
  linkProjectHelperMessage: {
    id: 'frontbucket.jiraTab.projectMenu.linkProjectHelperMessage',
    description:
      'Helper message describing manual and automatic linking process.',
    defaultMessage:
      'To link a project, add issue keys to commit message or pull request title. Alternatively you can manually link projects below.',
  },
  manageLinkedProjectsButtonLabel: {
    id: 'frontbucket.jiraTab.projectMenu.manageLinkedProjectsButtonLabel',
    description:
      'Dropdown button label to open the manage linked projects modal.',
    defaultMessage: 'Manage linked projects',
  },
  manageLinkedProjectsNotAllowedTooltipText: {
    id: 'frontbucket.jiraTab.projectMenu.manageLinkedProjectsNotAllowedTooltipText',
    description:
      'Text in the tooltip for disabled button to open manage linked project modal.',
    defaultMessage:
      '<p>You need <em>repository write</em> permission to link a Jira project to this repository</p>',
  },
});
